const contacts = {
  email: 'support@cirrus.com',
  phone: '1-800-975-5304',
  addresses: [
    {
      title: 'Palo Alto',
      descr: 'R&D',
      name: 'CiRRUS Inc.',
      street: '380 University Avatue',
      zip: '94301',
      city: 'Palo Alto',
      country: 'United States of America',
      email: 'info@cirrus.com',
    },
    {
      title: 'Lucerne',
      descr: 'Headquarter & R&D',
      name: 'BiCA AG',
      street: 'Buzibachstrasse 45',
      zip: 'CH-6023',
      city: 'Rothenburg',
      country: 'Switzerland',
      phone: '+41 41 289 05 05',
      email: 'info@bica.ch',
    },
  ],
  social: [],
};

export default contacts;
